<script>
  import { App as CapApp } from '@capacitor/app'
  import { StatusBar } from '@capacitor/status-bar'
  import { Capacitor } from '@capacitor/core'
  import Collapse from '../node_modules/bootstrap/js/dist/collapse.js'

  import { Router, Route, Link, navigate } from 'svelte-navigator'
  import { _ } from 'svelte-i18n'

  import Exercises from './routes/Exercises.svelte'
  import WorkoutPlans from './routes/WorkoutPlans.svelte'
  import Workouts from './routes/Workouts.svelte'
  import NavbarUserField from './components/NavbarUserField.svelte'
  import LoginHandling from './routes/LoginHandling.svelte'
  import Profile from './routes/Profile.svelte'

  // When navigating to a new page, scroll to top
  history.pushState = new Proxy(history.pushState, {
    apply(target, thisArg, argumentsList) {
      Reflect.apply(target, thisArg, argumentsList)
      setTimeout(
        () =>
          scrollTo({
            top: 0,
            left: 0,
            behavior: 'instant',
          }),
        100
      )
    },
  })

  // Native App Handling for Customer URL Schemes
  function capNavigate(url) {
    const i = url.indexOf('://')
    const r = '/' + url.substring(i + 3)
    console.log('Navigating to ' + r + ' (as i=' + i + ' of url ' + url + ')')
    navigate(r)
  }

  CapApp.addListener('appUrlOpen', (data) => {
    console.log('App opened with URL: ' + JSON.stringify(data))
    if (data && data['url']) {
      capNavigate(data['url'])
    }
  })

  const checkAppLaunchUrl = async () => {
    const url = await CapApp.getLaunchUrl()
    if (url && url['url']) {
      capNavigate(url['url'])
    }
  }
  checkAppLaunchUrl()

  // Android Special Handling: Hide Back Button and add more top margin to Navbar
  let isAndroid =
    Capacitor.isNativePlatform() && Capacitor.getPlatform() === 'android'

  // Collapsed NavBar Handling: When clicking links, collapse navbar again
  let menuToggle
  function collapseNavbar() {
    if (menuToggle && menuToggle.classList.contains('show')) {
      new Collapse(menuToggle).hide()
    }
  }

  // Correct Color for the Statusbar on Android
  if (Capacitor.isNativePlatform()) {
    StatusBar.setBackgroundColor({ color: '#c64345' })
  }
</script>

<Router>
  <nav
    class="navbar sticky-top navbar-expand-sm navbar-dark bg-primary"
    class:navbar-android={isAndroid}
  >
    <div class="container-fluid">
      {#if !isAndroid}
        <a
          class="navbar-brand"
          on:click|preventDefault={() => navigate(-1)}
          title="Back"
          aria-label="Back to previous page"
          href="/"
        >
          <i class="bi bi-chevron-left" />
        </a>
      {/if}
      <Link class="navbar-brand" to="/"><i class="bi bi-trophy" /> Fich</Link>
      <button
        class="navbar-toggler"
        type="button"
        data-bs-toggle="collapse"
        data-bs-target="#navbarSupportedContent"
        aria-controls="navbarSupportedContent"
        aria-expanded="false"
        aria-label="Toggle navigation"
      >
        <span class="navbar-toggler-icon" />
      </button>
      <div
        class="collapse navbar-collapse"
        id="navbarSupportedContent"
        bind:this={menuToggle}
      >
        <ul class="navbar-nav me-auto">
          <li class="nav-item">
            <Link class="nav-link" to="/exercises" on:click={collapseNavbar}
              >{$_('nav.exercises')}</Link
            >
          </li>
          <li class="nav-item">
            <Link class="nav-link" to="/workoutplans" on:click={collapseNavbar}
              >{$_('nav.workoutplans')}</Link
            >
          </li>
          <li class="nav-item">
            <Link class="nav-link" to="/workouts" on:click={collapseNavbar}
              >{$_('nav.workouts')}</Link
            >
          </li>
        </ul>
        <ul class="navbar-nav ms-auto">
          <NavbarUserField on:linkClick={collapseNavbar} />
        </ul>
      </div>
    </div>
  </nav>
  <div class="container pt-4 pb-4">
    <Route path="/exercises/*">
      <Exercises />
    </Route>
    <Route path="/workoutplans/*">
      <WorkoutPlans />
    </Route>
    <Route path="/workouts/*">
      <Workouts />
    </Route>
    <Route path="/login_redirect/">
      <LoginHandling />
    </Route>
    <Route path="/profile/">
      <Profile />
    </Route>
    <Route path="/users/:id" let:params>
      <Profile id={params.id} />
    </Route>
  </div>
</Router>

<style>
  .nav-item :global(a) {
    color: rgba(255, 255, 255, 0.75) !important;
  }

  .nav-item :global(a[aria-current='page']) {
    color: white !important;
  }

  .nav-item :global(a:focus) {
    color: white !important;
  }

  .navbar {
    padding-top: max(env(safe-area-inset-top), 0.5rem);
  }

  .navbar-android {
    padding-top: 0.5rem;
  }
</style>
